import Box from '@mui/material/Box';
import { CircularProgress } from '@mui/material';

type Size = 'extrasmall' | 'small' | 'medium' | 'large';

interface SizeProp {
    size?: Size | undefined;
    position?: 'flex-start' | 'center' | 'flex-end';
}

const getSize: (size?: Size | undefined) => string | undefined = (size?: Size | undefined) => {
    const sizeValue = {
        extrasmall: '1.2em',
        small: '1.6em',
        medium: '2em',
        large: '2.5em'
    };
    return size && sizeValue[size];
};
export default function Loading({ size, position }: SizeProp) {
    return (
        <Box sx={{ justifyContent: position || 'center', display: 'flex', margin: '5px 0' }}>
            <CircularProgress size={getSize(size || 'small')} />
        </Box>
    );
}
